import reportsEndpoints from './reports.endpoints';

const reportsModule = {
    namespaced: true,
    state: () => ({
        ReportSettings: {
            IDTextSettings: {},
            OtherActionSettings: [],
            ShowSettings: {}
        },
        FaultPictureCodes: []
    }),
    mutations: {
        setReportSettings(state, reportSettings) {
            state.ReportSettings = reportSettings;
        },
        setFaultPictureCodes(state, codes) {
            state.FaultPictureCodes = codes;
        }  
    },
    actions: {
        getReportSettings({ commit }) {
            return reportsEndpoints.getReportSettings().then((response) => {
                commit('setReportSettings', response);
            });
        },
        updateReportSettings({ dispatch }, dto) {
            return reportsEndpoints.updateReportSettings(dto).then(() => {
                return Promise.all([
                    dispatch('getReportSettings'),
                ]);
            });
        },
    },
};

export default reportsModule;
